import React from 'react';
import { createRoot } from 'react-dom/client';
import { GasToastProvider } from '../../shared/kit';
import App from './App';
import type { ShopCheckoutInitData } from './types';
import './style.css';

const mountEl = document.getElementById('gas-shop-checkout-app');

if (mountEl?.dataset.reactInit && mountEl.isConnected) {
    let initData: ShopCheckoutInitData;
    try {
        initData = JSON.parse(mountEl.dataset.reactInit) as ShopCheckoutInitData;
    } catch (error) {
        window.console?.error?.('[gas-shop-checkout] init JSON invalide', error);
        initData = {} as ShopCheckoutInitData;
    }

    createRoot(mountEl).render(
        <React.StrictMode>
            <GasToastProvider>
                <App initData={initData} />
            </GasToastProvider>
        </React.StrictMode>,
    );
}
